import React, { ReactNode } from 'react';

/**
 * @typedef {ReleaseNoteProps}
 * @property {string} header a title to use in the h3 header for this section
 * @property {string[]} items a list of items to render as <li> elements
 */
interface ReleaseNoteProps {
    header: string;
    items: ReactNode[];
}

/**
 * Renders a section from a given release note, either "new" or "fixes".
 * @param {ReleaseNoteProps} props
 */
export const ReleaseNoteSection = ({
    header,
    items,
}: ReleaseNoteProps): JSX.Element => (
    <>
        <h3>{header}</h3>
        <ul>
            {items.map(
                (item: ReactNode, index: number): JSX.Element => (
                    // This is a static list of items, so it's safe to use array indexes as keys.
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index}>{item}</li>
                ),
            )}
        </ul>
    </>
);
